export { useSyncMobilePromotionDetails } from './useSyncMobilePromotionDetails';
